import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import { Behavior } from '@prisjakt/ui/text';
import { TitleSmallText } from '@prisjakt/ui/text/variants';
import { useOfferListFilterContext } from 'src/areas/product/components/offer-list-filter-context';
import { getFractalRepresentation, getSizeTitle } from './utils';
import { DropdownButtonText } from './styles';
import { FilterTypeEnum } from 'src/components/price-list/types';

export const SizeVariantsButtonLabel = () => {
  const { t, market } = useAppContext();
  const { getFilter } = useOfferListFilterContext();
  const title = getSizeTitle(t, market);
  const variantSizeFilter = getFilter(FilterTypeEnum.VARIANT_SIZE);
  const selectedSizeVariants = variantSizeFilter?.active
    ? variantSizeFilter?.selection
    : null;
  const selectedVariants =
    (selectedSizeVariants?.length &&
      selectedSizeVariants
        .sort()
        .map(x => getFractalRepresentation(x))
        .join(', ')) ??
    t('product', 'variants.all');
  const buttonText = `${title}: ${selectedVariants}`;

  return (
    <DropdownButtonText behavior={Behavior.OnelineEllipsis}>
      <TitleSmallText>{buttonText}</TitleSmallText>
    </DropdownButtonText>
  );
};
